var map = {
	"./bo.json": [
		5600,
		42
	],
	"./en.json": [
		790,
		551
	],
	"./km.json": [
		655,
		359
	],
	"./ko.json": [
		7697,
		275
	],
	"./lo.json": [
		6583,
		576
	],
	"./my.json": [
		6091,
		312
	],
	"./ug.json": [
		1316,
		812
	],
	"./ug_cyrillic.json": [
		7512,
		213
	],
	"./ug_latin.json": [
		9857,
		120
	],
	"./vi.json": [
		245,
		811
	],
	"./zh_CN.json": [
		1662,
		828
	],
	"./zh_HK.json": [
		8295,
		960
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2395;
module.exports = webpackAsyncContext;